// NEW_FILE_JUSTIFIED: Review form state for ImportPolicyDialog — extracted to stay under 2-useState-per-component limit
import { useState, useCallback } from 'react';

export function useImportReviewForm() {
  const [selectedTypeId, setSelectedTypeId] = useState('');
  const [policyNumber, setPolicyNumber] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);

  const setTypeId = useCallback((id: string) => setSelectedTypeId(id), []);

  const addFiles = useCallback((files: File[]) => {
    setPendingFiles(prev => {
      const existingNames = new Set(prev.map(f => f.name));
      const newFiles = files.filter(f => !existingNames.has(f.name));
      return [...prev, ...newFiles];
    });
  }, []);

  const removeFile = useCallback((index: number) => {
    setPendingFiles(prev => prev.filter((_, i) => i !== index));
  }, []);

  const resetForm = useCallback(() => {
    setSelectedTypeId('');
    setPolicyNumber('');
    setCustomerName('');
    setPendingFiles([]);
  }, []);

  return {
    selectedTypeId,
    policyNumber,
    customerName,
    pendingFiles,
    setTypeId,
    setPolicyNumber,
    setCustomerName,
    addFiles,
    removeFile,
    resetForm,
  };
}
